import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
import scrollEffect from "./lib/scrollEffect.js";
import gsap from "gsap";
//import topValidation from 'top-validation';
import { isPage, isMobile } from "./lib/util";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import '@/scss/design.scss';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
//import observer from "./lib/observer.js";
import { Gradient } from './Gradient.js'

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
  scrollEffect();
  gsap.registerPlugin(ScrollTrigger,ScrollToPlugin);

  /*------------ sp nav button ------------*/
  if (window.matchMedia("(max-width: 767px)").matches) {
    const buttons = document.querySelectorAll('.hd-menu-btn');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const nextNav = btn.nextElementSibling;
        const isActive = btn.classList.contains('is-active');

        document.querySelectorAll('.hd-menu-btn, .pulldown-nav-wrap').forEach(el => {
          el.classList.remove('is-active');
        });

        if (!isActive) {
          btn.classList.add('is-active');
          if (nextNav && nextNav.classList.contains('pulldown-nav-wrap')) {
            nextNav.classList.add('is-active');
          }
        }
      });
    });

    // SP
    const navBtns = document.querySelectorAll('.pulldown-nav-btn');
    navBtns.forEach(navBtn => {
      navBtn.addEventListener('click', () => {
        document.querySelectorAll('.hd-menu-btn, .pulldown-nav-wrap').forEach(el => {
          el.classList.remove('is-active');
        });
      });
    });
  }

  /*------------ scroll reveal ------------*/
  gsap.utils.toArray(".js-scroll-reveal").forEach((el) => {
    gsap.from(el, {
      opacity: 0,
      y: 30,
      duration: 1,
      ease: "power2.out",
      scrollTrigger: {
        trigger: el,
        start: "top 87%",  // 画面の下から10%
        toggleActions: "play none none none", // 一度だけアニメーション
        once: true // 一度表示されたら繰り返さない
      }
    });
  });

  /*------------ TEST ------------*/
  gsap.utils.toArray(".js-scroll-visual").forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      start: "top 85%",
      onEnter: () => el.classList.add("is-show"),
    })
  })

});

/*------------ nav current ------------*/
document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const path = window.location.pathname; // 今のURLのパス部分を取得
  let currentWrap;

  // currentWrap を取得する
  if (path.includes("/rise")) {
    currentWrap = document.querySelector('.hd-nav-item .is-rise')
      ?.closest(".hd-nav-item")
      .querySelector(".pulldown-nav-wrap");
  } else if (path.includes("/pds")) {
    currentWrap = document.querySelector('.hd-nav-item .is-pds')
      ?.closest(".hd-nav-item")
      .querySelector(".pulldown-nav-wrap");
  }

  if (!currentWrap) return;

  const navBtns = currentWrap.querySelectorAll(".pulldown-nav-btn");

  navBtns.forEach((btn) => {
    const href = btn.getAttribute("href");
    if (!href || !href.includes("#")) return;

    const id = href.split("#")[1];
    const target = document.getElementById(id);
    if (!target) return;

    ScrollTrigger.create({
      trigger: target,
      start: "top center+=120vw",
      end: "bottom center-=120vw",
      onEnter: () => setCurrent(btn, navBtns),
      onEnterBack: () => setCurrent(btn, navBtns),
    });
  });

  function setCurrent(activeBtn, navBtns) {
    navBtns.forEach((btn) => btn.classList.remove("is-current"));
    activeBtn.classList.add("is-current");
  }
});


/*------------ index mv ------------*/
document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  if (!document.body.classList.contains("index")) {
    return;
  }

  gsap.set([".mv-img", ".mv-block", ".main-copy", ".sub-copy"], {
    autoAlpha: 0,
    filter: "blur(30px)",
  });

  // タイムライン
  const tl = gsap.timeline({ defaults: { duration: 1.5, ease: "power2.out" } });

  tl.to(".mv-img", { autoAlpha: 1, filter: "blur(0px)", y: 0 })
    .to(".mv-block", { autoAlpha: 1, filter: "blur(0px)", y: 0 }, ">-0.9")
    .to(".main-copy", { autoAlpha: 1, filter: "blur(0px)", y: 0 }, ">-0.5")
    .to(".sub-copy", { autoAlpha: 1, filter: "blur(0px)", y: 0 }, ">-0.5");
});

/*------------ sub mv ------------*/
document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  if (document.body.classList.contains("index")) {
    return;
  }

  gsap.set([".page-ttl", ".breadcrumb", ".sub-mv-img", ".sub-mv-lead-txt"], {
    autoAlpha: 0,
    filter: "blur(30px)",
  });

  const tl = gsap.timeline({ defaults: { duration: 1.3, ease: "power2.out" } });

  tl.to(".page-ttl", { autoAlpha: 1, filter: "blur(0px)", y: 0 })
    .to(".breadcrumb", { autoAlpha: 1, filter: "blur(0px)", y: 0 }, ">-1.2")
    .to(".sub-mv-img", { autoAlpha: 1, filter: "blur(0px)", y: 0 }, ">-0.6")
    .to(".sub-mv-lead-txt", { autoAlpha: 1, filter: "blur(0px)", y: 0 }, ">-0.7");
});

/*------------ page link ------------*/
document.addEventListener("DOMContentLoaded", () => {
  const navBtns = document.querySelectorAll(".pulldown-nav-btn");

  // === 設定値 ===
  const breakpoint = 768;     // SP 判定の幅
  const pcHeaderHeight = 130; // PC時の固定ヘッダー高さ
  const spHeaderHeight = 110; // SP時の固定ヘッダー高さ

  // 管理バーがある場合は加算（WordPress想定）
  const getAdminBarHeight = () => {
    const bar = document.getElementById("wpadminbar");
    return bar ? bar.offsetHeight : 0;
  };

  // PC/SP & 管理バーを考慮してオフセット高さを算出
  const getHeaderHeight = () => {
    const base = (window.innerWidth < breakpoint) ? spHeaderHeight : pcHeaderHeight;
    return base + getAdminBarHeight();
  };

  // 目標要素にヘッダー分オフセットしてスクロール
  const scrollWithOffset = (hash, behavior = "smooth") => {
    if (!hash) return;
    const target = document.querySelector(hash);
    if (!target) return;

    const headerH = getHeaderHeight();
    const y = target.getBoundingClientRect().top + window.scrollY - headerH;

    window.scrollTo({ top: y, behavior });
  };

  // レイアウト確定のタイミング差を吸収するために2段階で再補正
  const settleAndScroll = (hash) => {
    // 1回目：次フレームで（ブラウザのデフォルトスクロール直後）
    requestAnimationFrame(() => {
      scrollWithOffset(hash, "auto");
      // 2回目：さらに少し待ってから（Webフォント/画像でズレた場合）
      setTimeout(() => scrollWithOffset(hash, "auto"), 120);
    });
  };

  // ===== クリック時：同一ページならスムーススクロール、別ページは通常遷移 =====
  navBtns.forEach(btn => {
    btn.addEventListener("click", (e) => {
      const href = btn.getAttribute("href");
      if (!href) return;

      const url = new URL(href, window.location.origin);
      const targetPath = url.pathname.replace(/\/$/, "");
      const targetHash = url.hash;
      const currentPath = window.location.pathname.replace(/\/$/, "");

      if (currentPath === targetPath && targetHash) {
        e.preventDefault();
        scrollWithOffset(targetHash, "smooth");
      }
      // 別ページは普通に遷移 → 遷移後の load で補正する
    });
  });

  // ===== 遷移後（別ページ到着時）・直開き対応 =====
  // 画像/フォント読み込み完了後に補正
  window.addEventListener("load", () => {
    if (window.location.hash) {
      settleAndScroll(window.location.hash);
    }
  });

  // ハッシュだけ変わった場合の再補正（同一ページ内のリンクにも有効）
  window.addEventListener("hashchange", () => {
    if (window.location.hash) {
      settleAndScroll(window.location.hash);
    }
  });

  // 画面回転やリサイズでヘッダー高さが変わる場合の再補正（任意）
  let resizeTimer;
  window.addEventListener("resize", () => {
    if (!window.location.hash) return;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => settleAndScroll(window.location.hash), 150);
  });
});

/*------------ split Text Button ------------*/
let newText = '';
let spanText = '';
let newTextBefore = '';
let newTextAfter = '';

/* spanタグに分割 */
let splitTarget = document.querySelectorAll('.js-splitTextButton .js-splitText');//ターゲットとなる要素を全取得
splitTarget.forEach((target) => {// target = ターゲット
  if(!target.classList.contains('is-active')){//ターゲットが'is-active'クラスを持っていない場合
    newText = '';//生成する要素を格納するための変数
    spanText = target.innerHTML;//ターゲットの中身を取得
    spanText.split('').forEach((char) => {// char = character 文字
      if (char === ' ') { // スペースの処理
        newText += '<span style="display:inline-block; width:0.5em;">&nbsp;</span>';
      } else {
        newText += `<span>${char}</span>`;//一文字ずつspanタグで囲む
      }
    });
    newTextBefore = `<div class='before'>${newText}</div>`;//beforeクラスをつけた要素を生成
    newTextAfter = `<div class='after'>${newText}</div>`;//afterクラスをつけた要素を生成
    newText = `<span class='split_txt_wrap'>${newTextBefore + newTextAfter}</span>`;//before after両要素を囲む要素生成
    target.innerHTML = newText;//ターゲットに生成した要素を挿入
  }
});

var winW = window.innerWidth;
var spW = 768;

if (winW >= spW) {

  /* ターゲットにホバーした時の動き */
  let splitTargetButton = document.querySelectorAll('.js-splitTextButton');//ターゲットのボタン
  splitTargetButton.forEach((target)=>{
    if(!target.classList.contains('is-active')){//ターゲットが'is-active'クラスを持っていない場合
      let beforeSpan = target.querySelector('.before').querySelectorAll('span');//beforeの中にあるspanタグを全取得
      let afterSpan = target.querySelector('.after').querySelectorAll('span');//afterの中にあるspanタグを全取得
      target.addEventListener('mouseenter',()=>{//ホバーしたとき
        gsap.to(beforeSpan,{y:'-100%',stagger:.04,ease:"power2.out"})//0.03秒おきに各spanタグをy軸上に移動
        gsap.to(afterSpan,{y:'0%',stagger:.04,ease:"power2.out"})
      })
      target.addEventListener('mouseleave',()=>{//ホバーが外れたとき
        gsap.to(beforeSpan,{y:'0%',stagger:.04,ease:"power2.out"})
        gsap.to(afterSpan,{y:'100%',stagger:.04,ease:"power2.out"})
      })
    }
  })
}

/*------------ text animation ------------*/
document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".js-txt-anime");

  const wrapTextWithSpan = (node, countRef) => {
    const fragment = document.createDocumentFragment();

    if (node.nodeType === Node.TEXT_NODE) {
      [...node.textContent].forEach((char) => {
        if (char === "\n") {
          fragment.appendChild(document.createElement("br"));
        } else {
          const span = document.createElement("span");
          span.innerHTML = char === " " ? "&nbsp;" : char;
          span.style.transitionDelay = `${countRef.count * 0.05}s`;
          fragment.appendChild(span);
          countRef.count++;
        }
      });
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const clone = node.cloneNode(false); // <span> だけ複製（中身なし）
      node.childNodes.forEach((child) => {
        clone.appendChild(wrapTextWithSpan(child, countRef)); // 再帰処理
      });
      fragment.appendChild(clone);
    }

    return fragment;
  };

  targets.forEach((el) => {
    const textNodes = Array.from(el.childNodes);
    el.innerHTML = "";

    const countRef = { count: 0 };

    textNodes.forEach((node) => {
      const wrapped = wrapTextWithSpan(node, countRef);
      el.appendChild(wrapped);
    });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.2,
    }
  );

  document.querySelectorAll(".js-txt-anime").forEach((el) => {
    observer.observe(el);
  });
});

/*------------ gradation background ------------*/
// Create your instance
const gradient = new Gradient()
// Call `initGradient` with the selector to your canvas
gradient.initGradient('#gradient-canvas')

/*------------ Lenis ------------*/
const lenis = new Lenis()
function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}
requestAnimationFrame(raf)

/*------------ hash delete ------------*/
$(function(){
  const hash = decodeURI(location.hash);
  if(hash){
    const offset = $(window).width() > 768 ? 130 : 110; // 768px以上をPC、それ以下をSPと判定
    const targetTop = $(hash).offset().top - offset;

    $("html, body").animate({scrollTop: targetTop}, 400); // 400msでスクロール
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  }
});